(function($) {

  var extraTemplate = {
      html : function(showAmount) {

        showAmount = showAmount === undefined ? true : showAmount;

        return '<div class="row %type%">' +
               '<div class="small-8 columns">' + (showAmount ? '<strong>%amount%</strong> x ':'') + '%title%</div>' +
               '<div class="small-4 columns text-right"><span class="price">%price%€</span></div>' +
               '</div>';
      },

      render: function(tokens) {
        var html = this.html(tokens.amount !== undefined);
        for(token in tokens) {
          html = html.replace('%'+token+'%', tokens[token]);
        }
        return html;
      }
  };

  var complementContainer = function(selector, title) {
    this.selector = selector;
    this.title = title;
    this.container = $(selector);
    this.container.html('');

    return {
      addComplement: function(complement) {
        if (this.container.find('.booking-block-title').length === 0) {
          this.container.append('<div class="booking-block-title">'+ this.title + '</div>');
        }
        this.container.append(extraTemplate.render(complement));
      }.bind(this)
    }
  }

  function updatePrice(category, equip, price) {
    var $elems = $('.js-renting-'+category+ (equip !== null?'-'+equip:''));

    $elems.show();

    if (price === 0 || price === '' || price === null) {
       $elems.hide();
    }

    $elems.each(function(){
      var $elem = $(this);
      if ($elem.prop('tagName') === 'DIV') {
        replacePrice($elem.find('.js-price'), price);
      }

      if ($elem.prop('tagName') === 'OPTION') {
        replacePrice($elem, price);
      }
    });
  }

  function replacePrice($elem, price) {
    if ($elem.data('template') === undefined) {
      $elem.data('template', $elem.text());
    }

    $elem.text($elem.data('template').replace('%price%', price));
  }

  function updateRentingPrices() {
    var id = $('.js-shop-select').val(),
        prices = UNISKI_SETTINGS.shopRates[id],
        days   = UNISKI_SETTINGS.activityDays;

    for(category in prices) {
      if (prices[category] instanceof Object &&
          prices[category][1] === undefined ) {
        for(equip in prices[category]) {
          updatePrice(category, equip, prices[category][equip][days]);
        }
      } else if (prices[category] instanceof Object &&
                 prices[category][1] !== undefined ) {
        updatePrice(category, null, prices[category][days]);
      }
    }

    updateBookingBox();

  }

  function getRole(age, rules) {

    if (age > rules['maxJuniorAge']) return 'adult';
    else if (age > rules['maxKidsAge']) {
      return 'junior';
    }
    else if (age > rules['maxFreeAge']) {
      return 'kid';
    }

    return 'free';
  }

  function validateForm() {

    //Validate attached extras amount
    return $('.extra.js-attached .js-extra-select').each(function() {
      var $elem = $(this),
          role  = $elem.data('role'),
          rules = $elem.closest('.extra').data('booking-conditions'),
          people = $('.extra-person'),
          pRole, i, $people, extraName, activityName,
          total = 0;

      for (i = 0; i < people.length; i++) {
        $people = $(people[i]);
        pRole = getRole($people.find('input[type=hidden]').val(), rules);
        if (pRole == role) total += parseInt($people.find('select.js-forfait-select').val());
      }

      if (total < $elem.val()) {
        extraName    = $elem.closest('.extra').data('name');
        activityName = UNISKI_SETTINGS.activityName;
        Utils.showMessage(extraName, 'El extra ' + extraName + ' no permite elegir más del total de personas que disfrutaran de los ' + activityName);
        $elem.val(0);
        return false;
      }

      return true;

    });
  }

  function updateBookingBox() {

    if (!validateForm()) return null;

    $('.booking-box').addClass('js-calculating');
    $.post(UNISKI_SETTINGS.baseURL+'book/calculate', $('#booking-form').serialize())
    .then(function(res) {

      var container;

      $('.booking-box').removeClass('js-calculating');

      if (res['extras'] !== undefined) {
        container = new complementContainer('.js-extras-wrapper', 'Extras');
        for(var key in res['extras']){            
          var extra = res['extras'][key];
          extra['type'] = 'extra';
          container.addComplement(extra);          
        }
      }

      if (res['insurances'] !== undefined) {
        container = new complementContainer('.js-insurance-wrapper', 'Seguros');
        insurancePacks = 0;
        for (var key in res['insurances']) {
          var insurance = res['insurances'][key];
          insurance['type'] = 'insurance';
          container.addComplement(insurance);
          insurancePacks += insurance.amount;
        }
        $('.js-insurance-amount').text(insurancePacks);
      }

      if (res['renting'] !== undefined) {
        container = new complementContainer('.js-complements-wrapper', 'Complementos');
        rentingPacks = 0;
        for (var key in res['renting']) {
          var renting = res['renting'][key];
          renting['type'] = 'renting';
          container.addComplement(renting);
          rentingPacks += renting.amount;
        }
        $('.js-renting-amount').text(rentingPacks);
      }

      if (res['discounts'] !== undefined) {
        container = new complementContainer('.js-discounts-wrapper', 'Descuentos');
        for (var key in res['discounts']) {
          var discount = res['discounts'][key];
          discount['type'] = 'discount';
          container.addComplement(discount);
        }
      }

      if (res['taxes'] !== undefined) {
        container = new complementContainer('.js-taxes-wrapper', 'Tasas');
        for (var key in res['taxes']) {
          var tax = res['taxes'][key];
          tax['type'] = 'tax';
          container.addComplement(tax);
        }
      }

      if (res['extrasPrice'] !== undefined) {
        for(var key in res['extrasPrice']) {
          $('#js-extra-price-' +  key).text(res['extrasPrice'][key]);
        }
      }

      $('.js-forfait-amount').text(res['usersAmount']);

      //Groups
      $('.js-activity-amount').text($('.js-people-select').val());

      $('.js-total').text(res['total'] !== null ? res['total'] + ' €': 'n/a' );

    })
  }

  //Bind Events
  $('.js-shop-select').change(updateRentingPrices);
  $('.js-renting-select').change(updateBookingBox);
  $('.js-insurance-select').change(updateBookingBox);
  $('.js-forfait-select').change(updateBookingBox);
  $('.js-people-select').change(updateBookingBox);

  $('.js-payment-select').change(function() {
    var $this = $(this),
        val = $this.val();
    $('.js-payment-method').val(val);
  });

  $('.js-clone-typing').change(function() {
    $clone = $('#' + $(this).data('clone-to'));
    $clone.val($(this).val());
  });

  $('.js-clone-typing').each(function() {
    $clone = $('#' + $(this).data('clone-to'));
    $clone.val($(this).val());
  });

  $('.js-extra-select input[type=radio]').change(function() {
    var $formFields = $(this).closest('.extra-block').find('.extra-form').find('input, select');

    if ($(this).val() == 0) {
      $formFields.attr('disabled','disabled');   
    } else {
      $formFields.removeAttr('disabled');   
    }

    updateBookingBox();
  });

  $('.js-extra-forfait').change(updateBookingBox);
  $('.js-select-extra-date').change(updateBookingBox);

  $('.js-extra-button input[type=radio]').change(function() {
    $form = $(this).closest('.extra-block').find('.extra-form');
    if ($(this).val() == true) $form.show();
    else $form.hide();
  });

  //Validate form
  $('#booking-form').validate({
    rules: {
      'booking[user][email][first]' : {
        email: true,
        remote: {
          url: UNISKI_SETTINGS.baseURL + 'user/check-email',
          type: 'post',
          data: {
            token: function() { return 'uniski2017'; },
            email: function() { return $('#booking_user_email_first').val(); }
          }
        }
      },
      'booking[user][email][second]': {
        email: true,
        equalTo: '#booking_user_email_first'
      }
    },

    messages: {
      'booking[user][email][first]' : {
        remote: 'Ya existe un usuario con este email, si es usted inicie sessión con este usuario'
      },
      'booking[policy]': {
        required: "Debe aceptar la política de privacidad y condiciones de uso"
      }
    },

    errorPlacement: function(error, element) {
      if (element.attr('type') == 'checkbox') {
        error.insertAfter(element.closest('label'));
      } else {
        error.insertAfter(element);
      }
    }
  });

  //Init prices
  window.updateRentingPrices = updateRentingPrices;

})(jQuery);
